import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import ScrollLock from 'react-scroll-lock-component';
import bemify from 'bemify-js';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import Notification from 'app/viewport/components/Notification';
import NotificationShape from 'app/viewport/NotificationShape';
import { Div } from 'app/common/components/AccessibleElement';
import 'app/viewport/components/NotificationsDropdown.scss';

const bem = bemify('notifications-dropdown');

const NotificationsDropdown = createReactClass({
  displayName: 'NotificationsDropdown',
  mixins: [PureRenderMixin],

  propTypes: {
    notifications: PropTypes.arrayOf(PropTypes.shape(NotificationShape)),
    onClose: PropTypes.func.isRequired,
    onNotificationCta: PropTypes.func.isRequired,
    onDismissNotification: PropTypes.func.isRequired,
  },

  onClick(e) {
    if (e) {
      e.stopPropagation();
    }
  },

  render() {
    const { props } = this;
    const { notifications } = props;

    return (
      <Div className={bem()} onClick={this.onClick}>
        <ScrollLock>
          <div className={bem('__content')}>
            {notifications && notifications.length > 0 ? (
              <ul className={bem('__list')}>
                {notifications.map(notification => {
                  const onClick = () => {
                    props.onNotificationCta(notification);
                  };
                  const notificationProps = { ...notification, onClick };

                  return (
                    <Notification
                      {...notificationProps}
                      className={bem('__list-item')}
                      key={notification.id}
                      onDismissNotification={props.onDismissNotification}
                    />
                  );
                })}
              </ul>
            ) : (
              <div className="menu-notifications-empty">
                <div className="menu-notifications__empty-icon" />
                <h4 className="menu-notifications__title">No Notifications</h4>
              </div>
            )}
          </div>
        </ScrollLock>
      </Div>
    );
  },
});

export default NotificationsDropdown;
